import { PageId } from 'constants/pages'

export const enum PageIdWoofzPpday80 {
  SUBSCRIPTIONS_PPDAY_80_N = PageId.SUBSCRIPTIONS_PPDAY_80_N,
  CHAT_UPSELL_PPDAY_80 = PageId.CHAT_UPSELL_PPDAY_80,
  UPSELL_PPDAY_80 = PageId.UPSELL_PPDAY_80,
  DOWNLOAD_PPDAY_80 = PageId.DOWNLOAD_PPDAY_80,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
